import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-message-dialog',
  templateUrl: './message-dialog.component.html',
  styleUrls: ['./message-dialog.component.scss']
})
export class MessageDialogComponent {

  iconClass: string = 'fa fa-times error-icon'; 
  
  constructor(public dialogRef: MatDialogRef<MessageDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any){}


  ngOnInit(): void {
    console.log(this.data);
    this.iconClass = this.data.icon;
  }

  onClose(): void {
    this.dialogRef.close();
  }

}
